'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SpruceComponent = require('stampy/lib/util/SpruceComponent');

var _SpruceComponent2 = _interopRequireDefault(_SpruceComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _SpruceComponent2.default)('Choice', 'div');


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/Choice.js
// module id = 109
// module chunks = 35783957827783 114276838955818 162898551421021